import toast from "react-hot-toast"

const Notify = (msg, type) => {
  if (type === "error") {
    toast.error(msg, { duration: 6000 })
  } else if (type === "success") {
    toast.success(msg, {
      duration: 2000,
      iconTheme: {
        primary: "#b22222", // Custom check icon color
        secondary: "#ffffff", // Background color of the icon
      },
    })
  }
}

export default Notify
